import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';

import t from 'react-translate';

import { authorRatingsSorted } from 'redux/selectors/skills-feedback';
import { getCurrentUser } from 'redux/selectors/users';

import ClickableContainer from 'components/clickable-container';
import NvUserAvatar from 'components/nv-user-avatar';
import NvIcon from '../nv-icon';
import ViewFeedback from './view-feedback';

type AuthorFeedbackProps = {
  ownerId: number
  ownerKey: string
  createdAt: string
  submittedUserName: string
  onDelete: () => void
  pendoTag?: string
};

const AuthorFeedback = ({
  ownerId,
  ownerKey,
  createdAt,
  submittedUserName,
  onDelete,
  pendoTag,
}: AuthorFeedbackProps) => {
  const authorRatings = useSelector(state => authorRatingsSorted(state, ownerId, ownerKey));
  const author = useSelector(state => getCurrentUser(state));
  return (
    <div className='d-flex'>
      { author && (
        <div className='d-none d-md-block'>
          <NvUserAvatar
            borderType='round'
            size='md'
            user={author}
            displayName
            className='mx-4 mb-1 gray-2 text-small'
            directToOrgLevelProfile
            displayRoleBadge
          />
        </div>
      )}
      <div className='own-feedback-container w-100 flex-column'>
        { author && (
          <div className='d-block d-md-none mb-4'>
            <NvUserAvatar
              displayName
              inlineName
              displayRoleBadge={false}
              alignNameRight
              user={author}
              size='sm'
              borderType='round'
              directToOrgLevelProfile
            />
          </div>
        )}
        {authorRatings?.map(rating => (
          <ViewFeedback key={rating} ratingId={rating} isAuthor />
        ))}
        <div className='d-flex justify-content-between'>
          <ClickableContainer
            className='own-feedback d-flex gray-3 align-items-center'
            onClick={() => onDelete()}
            pendo-tag-name={pendoTag}
            aria-label={t.NOVOED.DELETE()}
          >
            <NvIcon icon='trash' size='xss-smallest' className='ml-2 mr-1' />
            {t.NOVOED.DELETE()}
          </ClickableContainer>
          <div className='text-date gray-2'>
            {moment(createdAt).format('lll')}
          </div>
        </div>
        <div className='text-small gray-3 ml-2 mt-6 '>
          {t.SKILLS_FEEDBACK.FEEDBACK_VISIBILITY.AUTHOR(submittedUserName)}
        </div>
      </div>
    </div>
  );
};

export default AuthorFeedback;
